import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed the light/dark color mode in the platform preview modal',
  name: 'canvas_platform_preview_color_mode_changed',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The color mode the user selected',
      name: 'color_mode',
      required: true,
      type: 'enum',
      values: ['light', 'dark'],
    },
    {
      description: 'The format id being previewed',
      name: 'format_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The Instagram feed/reel placement when previewing an Instagram Reel format',
      name: 'instagram_placement',
      required: false,
      type: 'enum',
      values: ['feed', 'reel'],
    },
  ],
};

export default META;
